import { useState, useEffect } from 'react';
import { ICheckInData } from 'mod/checkIn/interface';
import { getCheckInConfig, postCheckIn, postShare } from 'mod/checkIn/service';
import { Message } from '@base/lib/Message';
import { commonErrorHandler } from 'base/utils/api-callback';
import { checkPeriodActive } from 'base/utils/date';

export type ICheckInInstance = {
    data?: ICheckInData;
    loading: boolean;
    fetchData: () => Promise<void>;
    active: boolean;

    onCheckIn: () => Promise<void>;
    checkInResultVisible: boolean;
    cancelCheckInResult: () => void;

    shareResultVisible: boolean;
    cancelShareResult: () => void;
    shareCallback: (forceShowResult?: boolean) => Promise<void>;

};

export function useCheckIn(): ICheckInInstance {
    const [data, setCheckInInfo] = useState<ICheckInData>();
    const [loading, setLoading] = useState<boolean>(false);
    const [active, setActive] = useState<boolean>(false);

    const [checkInResultVisible, setCheckInResultVisible] = useState<boolean>(false);
    const [shareResultVisible, setShareResultVisible] = useState<boolean>(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await getCheckInConfig();
            setCheckInInfo(res);
            setActive(checkPeriodActive(res.startTimeSecond, res.endTimeSecond));

        } catch (e) {
            Message.error(e.message);
        }
        setLoading(false);
    }

    const onCheckIn = async () => {
        try {
            const res = await postCheckIn(data?.activityGid || '')
            if (res.checkIn) {
                setCheckInResultVisible(true);
            }
            fetchData();
        } catch (err) {
            commonErrorHandler(err);
        }
    };

    const shareCallback = async (forceShowResult = false) => {
        try {
            await postShare(data?.activityGid || '');
            if (forceShowResult || (data?.shareBoom.checkIn && !data?.shareBoom.boom)) {
                setShareResultVisible(true);
                fetchData();
            }
        } catch (e) {
            Message.error(e.message);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    return {
        data,
        loading,
        fetchData,
        active,
        onCheckIn,
        checkInResultVisible,
        cancelCheckInResult: () => setCheckInResultVisible(false),

        shareResultVisible,
        cancelShareResult: () => setShareResultVisible(false),
        shareCallback,
    }
}